// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/generic/generic.scss
 ** module id = 117
 ** module chunks = 0 1
 **/